export default "__VITE_ASSET__i8Ki2bw$__"